<!--
 * @Descripttion: 
 * @version: 
 * @Author: ankeji
 * @Date: 2021-12-10 15:34:21
 * @LastEditors: ankeji
 * @LastEditTime: 2021-12-10 15:46:23
-->
<!-- 所有产品的头部header和tab切换 -->
<template>
  <div>
    <!-- 头部信息-->
    <Head :product="product" />
    <!-- 选项卡 -->
    <Tab :product="product" />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Tab from "./tab.vue";
import Head from "./head.vue";
import planHtml from "../js/insuranceInfo.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { Head, Tab },
  data() {
    //这里存放数据
    return {
      product: {},
      planHtml,
    };
  },
  //监听属性 类似于data概念
  computed: {
    planContent() {
      let planCode = this.$route.query.planCode;
      if (planCode === "GFTYX20Htwo") {
        return this.planHtml.planTwoHtml;
      }
      return this.planHtml.planOneHtml;
    },
  },
  //监控data中的数据变化
  watch: {
    "$route.query.planCode": {
      handler(val) {
        let planContent = this.planHtml.planOneHtml;
        if (val === "GFTYX20Htwo") {
          planContent = this.planHtml.planTwoHtml;
        }
        this.product.tabDtos.forEach((item) => {
          if (item.tabName === "投保须知") {
            item.tabContent = planContent;
          }
        });
      },
    },
  },
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(this.planHtml);
    const { u, p } = this.$route.query;
    let userParams = {
      //从地址中获取
      userId: u,
      productCode: p,
    };
    this.$api.querproduct(userParams).then((res) => {
      let content = res.data.content;
      content.tabDtos = [
        ...content.tabDtos,
        {
          tabName: "信息披露",
          tabContent: ``,
        },
      ];
      content.tabDtos.forEach((item) => {
        if (item.tabName === "投保须知") {
          item.tabContent = this.planContent;
        }
      });
      this.product = content;
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
</style>